<div class="order">
  <h5>Order Summary</h5>
  <div class="line">
    <span>No.:</span> <span style="font-size: 0.875rem">{{order.id}}</span>
  </div>
  <div class="line">
    <span>Order Date:</span>
    <span>{{order.created_at|date:'short'}}</span>
  </div>
  <div class="line">
    <span>Order Status:</span>
    <span>{{order.status}}</span>
  </div>
  <div class="line">
    <span>Product Quantity:</span>
    <span>{{order.item_quantity|number}}</span>
  </div>
  <div class="line">
    <span>Subtotal:</span>
    <span><app-price [price]="order.subtotal"></app-price></span>
  </div>
  <div class="line">
    <span>Shipping Fee:</span>
    <span><app-price [price]="order.shipping_fee"></app-price></span>
  </div>
  <div class="line">
    <span>Total:</span>
    <span><app-price [price]="order.total"></app-price></span>
  </div>
</div>

<div class="shipping">
  <h5>Shipping Address</h5>
  <div class="address">
    <h6>{{order.shipping.name}}</h6>
    <p>{{order.shipping.line1}} {{order.shipping.line2}}</p>
    <p>
      {{order.shipping.city}}, {{order.shipping.state}},
      {{order.shipping.postal_code}}
    </p>

    <p>{{order.shipping.country}}</p>
  </div>
</div>
<div class="items">
  <h5>Product Details</h5>
  <div class="item-list">
    @for (item of order.items; track $index) {
    <app-user-order-item-list-item
      [item]="item"
    ></app-user-order-item-list-item>
    }
  </div>
</div>
